export const TEMPLATE = {
  TEMPLATE: 'template',
  TEMPLATE_LIST: 'template_list',
};
